module.exports = __webpack_public_path__ + "static/media/qatar-airways.54083e22.svg";